var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"pa-0 ma-0 padd"},[_c('h2',{staticClass:"font primary marginBot",staticStyle:{"font-size":"20px"}},[_vm._v(" Assigned to ")])]),_c('v-row',{staticClass:"header"},[_c('v-col',{attrs:{"cols":"6"}},[_c('FormRow',{attrs:{"fields":[
          {
            label: 'Evaluator',
            value: _vm.assignedTo.evaluator
          }
        ]}}),_c('FormRow',{attrs:{"fields":[
          {
            label: 'First Reviewer',
            value: _vm.assignedTo.firstPass
          }
        ]}}),_c('FormRow',{attrs:{"fields":[
          {
            label: 'Final Reviewer',
            value: _vm.assignedTo.final
          }
        ]}})],1)],1),_c('FormRow',{attrs:{"fields":[
      {
        label: 'PDBNF Status',
        value: _vm.notif.status
      },
      {
        label: 'DBN Number',
        value: _vm.notif.dbnNumber
      }
    ]}}),_c('FormRow',{attrs:{"fields":[
      {
        label: 'Name of PIC',
        value: _vm.notif.fullName
      },
      {
        label: 'Email Address',
        value: _vm.notif.email
      }
    ]}}),_c('FormRow',{attrs:{"fields":[
      {
        label: 'Representative',
        value: _vm.notif.representative
      },
      {
        label: 'Email Address',
        value: _vm.notif.contactInfo
      }
    ]}}),_c('FormRow',{attrs:{"fields":[
      {
        label: 'Date of Occurence',
        value: _vm.notif.dateOfOccurrence
      },
      {
        label: 'Date of Discovery',
        value: _vm.notif.dateOfDiscovery
      }
    ]}}),_c('FormRow',{attrs:{"fields":[
      {
        label: 'Date of Notification',
        value: _vm.notif.dateOfNotification
      },
      {
        label: 'Date of Evaluation',
        value: _vm.notif.dateOfEvaluation
      }
    ]}}),_c('v-row',{staticClass:"pa-0 ma-0 padd"},[_c('h2',{staticClass:"font primary",staticStyle:{"font-size":"20px","margin-top":"25px"}},[_vm._v(" Notification Type ")])]),_vm._l((_vm.notif.notifications),function(type,idx){return _c('v-row',{key:idx,staticClass:"font size padd"},[(type)?_c('v-col',[_c('v-row',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"}},[(type.checkbox)?_c('v-icon',{staticStyle:{"margin-right":"5px"},attrs:{"small":"","color":"black"}},[_vm._v(" mdi-check ")]):_vm._e(),_c('p',[_vm._v(" "+_vm._s(type.name)+" ")])],1),_c('v-row',{staticClass:"pa-0 ma-0"},[_c('v-col',{staticStyle:{"border":"0.1px solid #454545","border-right":"none"},attrs:{"cols":"3"}},[_vm._v(" "+_vm._s(type.subtype)+" ")]),_c('v-col',{staticStyle:{"border":"0.1px solid #454545"},attrs:{"cols":"9"}},[_vm._v(" Remarks: "+_vm._s(type.remarks)+" ")])],1)],1):_vm._e()],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }